<template>
  <v-dialog v-model="isModalShowing" persistent width="700">
      <template v-slot:activator="{ on }">
          <span v-on="on">
              <slot />
          </span>
      </template>
      <v-card data-test="confirm-cancel-observation-modal">
          <v-card-title>
              <h2 class="headline">{{ $t('modals.endObservationModal.title') }}</h2>
          </v-card-title>
          <v-card-text>
              <p>{{ $t('modals.endObservationModal.body') }}</p>
          </v-card-text>
          <v-card-actions>
              <v-btn text @click="cancelModal">{{ $t('modals.endObservationModal.cancel') }}</v-btn>
              <v-spacer />
              <!-- Show download button only if screen width is greater than 960px -->
              <v-btn @click="reset" color="error" data-test="confirm-end-tracking-button">{{ $t('modals.endObservationModal.endObservation') }}</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue'
import store from '@/store'
import { editUser } from '@/services/users'
import { eventBus } from "@/main";

export default Vue.extend({
  data(): { isModalShowing: boolean; teamName: string; screenWidth: number } {
      return {
          isModalShowing: false,
          teamName: '',
          screenWidth: window.innerWidth
      }
  },
  created() {
      this.teamName = store.state.authentication.currentUser.companyName
      window.addEventListener('resize', this.updateScreenWidth)
  },
  beforeDestroy() {
      window.removeEventListener('resize', this.updateScreenWidth)
  },
  methods: {
      updateScreenWidth() {
          this.screenWidth = window.innerWidth
      },
      triggerDownload() {
          eventBus.$emit('downloadChatConvo')
      },
      openModal() {
          this.isModalShowing = true
      },
      cancelModal() {
          this.isModalShowing = false
      },
      async reset() {
        this.isModalShowing = false
        store.dispatch('location/endObservationSession')
        eventBus.$emit('clearGeoJsonLayer')
      },
  },
  computed: {
      isScreenLarge(): boolean {
          return this.screenWidth > 960
      }
  }
})
</script>